module.exports = __webpack_public_path__ + "img/eco-efemerides.3dbcd132.png";